import React, { useRef } from 'react'
import { SIDRender, SLowcodeList, STriggerModal } from 'shj-components'
import config from './taskConfig'
import dayjs from 'dayjs'
import { getUser } from '@/common/utils';
import { getTaskAll, getTaskId } from '@/services/saleOpServices';
import { Button, message } from 'antd';
import wx_add from '@/assets/wx_add.svg'
import wx_add_ok from '@/assets/wx_add_ok.svg'
import { useNavigate } from 'react-router-dom';
import {openInNewTab} from "@/utils/queryParse.ts";
import {getAuth} from "@/utils/auth.ts";
import {useAtom} from "jotai";
import {callStateAtom} from "@/pages/callTool/intelligentOutboundCall/components/Info/store";
const TaskModal = props => {
  const { open, onClose } = props
  const listRef = useRef<any>()
  const auths = getAuth()
  const navigate = useNavigate()
  const [callState] = useAtom(callStateAtom)
  const defaultTaskNameMap = {
    NO_RESPOND: '未响应',
    NO_FOLLOW: '未有效',
  }
  const fetchList = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const user = getUser();
        getTaskAll(user?.ucenterUserId).then(data => resolve({ records: data }))
      } catch (e) {
        reject({ success: false })
      }
    })
  }
  const onTaskClick = async (data) => {
    const res: any = await getTaskId(data?.id);
    if (res['state'] == 'PROCESSED') {
      message.warning('任务已完成或者线索已被改派，无需再处理');
      return;
    } else {
      openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${data.clueId}`)
    }
  }
  const extension = {
    request: { fetchList },
    customRender: {
      taskTypeRender(_, record: any) {
        return <div>{defaultTaskNameMap[record.taskType]}</div>
      },
      clueIdRender(text: any, record: any, index: any) {
        const label = text
        return (
          <SIDRender
            id={label}
            onClick={() => {
              openInNewTab(`/mos/saleOp/salesWorkBench/salesWorkBenchDetail/${record.clueId}`)
            }}
          />
        )
      },
      nameRender(v, record) {
        return <div style={{ display: 'flex' }}>
          <img style={{ width: 20, height: 20, marginRight: 5 }} src={record.salesAddQvFlag ? wx_add_ok : wx_add} />
          {v}
        </div>
      },
      actionRender(_, record: Record<string, any>) {
        return (record.taskType == 'NO_RESPOND' && callState.isSeat && dayjs(record.expirationTime).diff() > 0) ?
            <Button style={{color: '#EB3723'}} type="link" size="small" onClick={() => { props.onTaskClick?.(record) }}>
          立即处理
        </Button> : null
      },
    },
  }
  return (
    <STriggerModal width={900} title={'更多紧急任务'} open={open} onCancel={onClose} footer={null}>
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} rowKey={'id'} />
    </STriggerModal>
  )
}

export default TaskModal
